import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { TextField, Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Link from "@material-ui/core/Link";

import PostMailResetPassword from "../PostMailResetPassword/PostMailResetPassword";
import { url } from "../../../../config/config";
import { useStyles } from "./PreMailResetPassword.css";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

class PreMailResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      next: false,
      notificationOpen: false,
      errorNotificationOpen: false,
      loading: true,
      buttonLoading: false,
    };
  }

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
      errorNotificationOpen: false,
    });
  };

  handleErrorNotificationOpen = () => {
    this.setState({
      errorNotificationOpen: true,
    });
  };

  showNotification = (severity, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen || this.state.errorNotificationOpen}
        onClose={this.handleNotificationClose}
        style={{ top: 80 }}
        autoHideDuration={3600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity={severity}
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.handleNotificationOpen();
    if (this.props.match.params.type === "Customer") {
      this.setState({ buttonLoading: true });
      const response = await Axios.post(`${url}/api/users/resetPassword`, {
        email: this.state.email,
      });
      if (response.data.success) {
        this.setState({
          loading: false,
          buttonLoading: false,
          next: true,
        });
        this.handleNotificationOpen();
      }
      if (response.data.error) {
        this.setState({ buttonLoading: false });
        this.handleErrorNotificationOpen();
      }
    }
    if (this.props.match.params.type === "Author") {
      this.setState({ buttonLoading: true });
      const response2 = await Axios.post(`${url}/api/authors/resetPassword`, {
        email: this.state.email,
      });
      if (response2.data.success) {
        this.setState({
          loading: false,
          buttonLoading: false,
          next: true,
        });
        this.handleNotificationOpen();
      }
      if (response2.data.error) {
        this.setState({ buttonLoading: false });
        this.handleErrorNotificationOpen();
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Link
          href="/"
          style={{ fontSize: 40, textDecoration: "none", color: "#181818" }}
        >
          Digi-Book
        </Link>
        {this.state.notificationOpen === true || this.state.loading === true
          ? this.state.loading === true
            ? this.showNotification("info", "Loading...")
            : this.showNotification("success", "email sent Successfully")
          : this.showNotification("error", "Invalid email")}
        {this.state.next === false ? (
          <form onSubmit={this.handleSubmit} className={classes.formStyle}>
            <label>Enter your email address in order to reset password</label>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <TextField
                name="email"
                type="email"
                required
                fullWidth
                variant="outlined"
                margin="normal"
                placeholder="Enter email address"
                style={{ width: "60%", outline: "none" }}
                InputProps={{
                  classes: {
                    root: classes.inputRoot,
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                type="submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                Send Password Reset Mail
              </Button>
              {this.state.buttonLoading && <FormLoader />}
            </div>
            <Link
              href={`/login/${this.props.match.params.type}`}
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                fontSize: 20,
              }}
            >
              I remember password
            </Link>
          </form>
        ) : (
          <div>
            <PostMailResetPassword type={this.props.match.params.type} />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(PreMailResetPassword)));
